import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_get_license_plates_for_adjustmentsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[], serialNumberIds?: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, DimensionsUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LocationId?: number, LookupCode?: string, MaximumWeight?: number, NetVolume?: number, NetWeight?: number, StatusId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Width?: number, LicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { MaterialId?: number } }[], Status?: { Name?: string }, Location?: { Name?: string, Status?: { Name?: string } }, SerialNumbers?: { Id?: number, Archived?: boolean, ChainHead?: number, DimensionUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, LotId?: number, NetVolume?: number, NetWeight?: number, Notes?: string, PackagingId?: number, StatusId?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, Packaging?: { Name?: string, ShortName?: string } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[], serialNumberIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, DimensionsUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LocationId?: number, LookupCode?: string, MaximumWeight?: number, NetVolume?: number, NetWeight?: number, StatusId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Width?: number, LicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { MaterialId?: number } }[], Status?: { Name?: string }, Location?: { Name?: string, Status?: { Name?: string } }, SerialNumbers?: { Id?: number, Archived?: boolean, ChainHead?: number, DimensionUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, LotId?: number, NetVolume?: number, NetWeight?: number, Notes?: string, PackagingId?: number, StatusId?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, Packaging?: { Name?: string, ShortName?: string } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[], serialNumberIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, DimensionsUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LocationId?: number, LookupCode?: string, MaximumWeight?: number, NetVolume?: number, NetWeight?: number, StatusId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Width?: number, LicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { MaterialId?: number } }[], Status?: { Name?: string }, Location?: { Name?: string, Status?: { Name?: string } }, SerialNumbers?: { Id?: number, Archived?: boolean, ChainHead?: number, DimensionUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, LotId?: number, NetVolume?: number, NetWeight?: number, Notes?: string, PackagingId?: number, StatusId?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, Packaging?: { Name?: string, ShortName?: string } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[], serialNumberIds?: number[]    }) {
      return false;
    }
}
